import React from "react";
import Hero from "@insightfulscience/atomic-react/Hero";
import HeroTitle from "@insightfulscience/atomic-react/Hero/Title";
import PageMeta from "@insightfulscience/smart-react/PageMeta";
import { useLocale } from "@insightfulscience/smart-react/i18";
import GuidePageTemplate from "@insightfulscience/atomic-react/GuidePageTemplate";
import GuidePageTemplateMain from "@insightfulscience/atomic-react/GuidePageTemplate/Main";
import {
	PostElementTitleH2,
	PostElementParagraph,
	PostElementListItem,
	PostElementOl,
	PostElementUl,
} from "@insightfulscience/atomic-react/PostElement";
import Html from "@insightfulscience/smart-react/Html";
import HeroDescription from "@insightfulscience/atomic-react/Hero/Description";
import Block from "@insightfulscience/atomic-react/Block";
import SiteLayout from "../../SiteLayout";
import SectionTryForFree from "../../SectionTryForFree";
import routes from "../../routes";

const ProductTerms = () => {
	const [t] = useLocale("product-terms");
	return (
		<SiteLayout>
			<PageMeta title={t("META.TITLE")} description={t("META.DESCRIPTION")}>
				<PageMeta.OGP
					locale={t("META.LOCALE")}
					type={t("META.TYPE")}
					title={t("META.TITLE")}
					description={t("META.DESCRIPTION")}
					url={t("META.URL")}
					siteName={t("META.SITE_NAME")}
					articlePublisher={t("META.ARTICLE_PUBLISHER")}
				/>
				<PageMeta.Canonical href={t("META.CANONICAL")} />
				<PageMeta.Twitter
					card={t("META.TWITTER_CARD")}
					title={t("META.TITLE")}
					description={t("META.DESCRIPTION")}
					site={t("META.TWITTER_SITE")}
					creator={t("META.TWITTER_CREATOR")}
				/>
			</PageMeta>
			<Hero color="black--02" spacing={{ pt: 20 }}>
				<HeroTitle>{t("HERO_TITLE")}</HeroTitle>
				<HeroDescription>{t("HERO_DESCRIPTION")}</HeroDescription>
			</Hero>
			<GuidePageTemplate sidebar={false}>
				<GuidePageTemplateMain sidebar={false}>
					<PostElementUl spacing={{ my: 8 }}>
						<PostElementListItem spacing={{ mb: 1 }}>
							<Html Tag="span">{t("OVERVIEW_LIST_ITEM_1", { url: "#general_terms" })}</Html>
						</PostElementListItem>
						<PostElementListItem spacing={{ mb: 1 }}>
							<Html Tag="span">{t("OVERVIEW_LIST_ITEM_2", { url: "#attachment_1" })}</Html>
						</PostElementListItem>
						<PostElementListItem spacing={{ mb: 1 }}>
							<Html Tag="span">{t("OVERVIEW_LIST_ITEM_3", { url: "#attachment_2" })}</Html>
						</PostElementListItem>
					</PostElementUl>

					<PostElementParagraph>
						<Html Tag="span">{t("MAIN_DESCRIPTION_1")}</Html>
					</PostElementParagraph>

					<PostElementTitleH2 id="general_terms">{t("SECTION_TITLE_1")}</PostElementTitleH2>
					<PostElementParagraph spacing={{ mt: 0 }}>
						<Html Tag="span">{t("SECTION_TITLE_1_1")}</Html>
					</PostElementParagraph>
					<PostElementParagraph>{t("SECTION_DESCRIPTION_1_1")}</PostElementParagraph>
					<PostElementParagraph>{t("SECTION_DESCRIPTION_1_2")}</PostElementParagraph>
					<PostElementParagraph>{t("SECTION_DESCRIPTION_1_3")}</PostElementParagraph>
					<PostElementParagraph>{t("SECTION_DESCRIPTION_1_4")}</PostElementParagraph>
					<PostElementParagraph>{t("SECTION_DESCRIPTION_1_5")}</PostElementParagraph>
					<PostElementParagraph>{t("SECTION_DESCRIPTION_1_6")}</PostElementParagraph>
					<PostElementParagraph>{t("SECTION_DESCRIPTION_1_7")}</PostElementParagraph>
					<PostElementParagraph>{t("SECTION_DESCRIPTION_1_8")}</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_DESCRIPTION_1_9")}</Html>
					</PostElementParagraph>
					<PostElementParagraph>{t("SECTION_DESCRIPTION_1_10")}</PostElementParagraph>
					<PostElementParagraph>{t("SECTION_DESCRIPTION_1_11")}</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">
							{t("SECTION_DESCRIPTION_1_12", { howToBuy: routes.external.howToBuy })}
						</Html>
					</PostElementParagraph>
					<PostElementParagraph>{t("SECTION_DESCRIPTION_1_13")}</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_DESCRIPTION_1_14")}</Html>
					</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_DESCRIPTION_1_15")}</Html>
					</PostElementParagraph>
					<PostElementParagraph>{t("SECTION_DESCRIPTION_1_16")}</PostElementParagraph>
					<PostElementParagraph>{t("SECTION_DESCRIPTION_1_17")}</PostElementParagraph>
					<PostElementParagraph>{t("SECTION_DESCRIPTION_1_18")}</PostElementParagraph>
					<PostElementParagraph>{t("SECTION_DESCRIPTION_1_19")}</PostElementParagraph>
					<PostElementParagraph>{t("SECTION_DESCRIPTION_1_20")}</PostElementParagraph>
					<PostElementParagraph>{t("SECTION_DESCRIPTION_1_21")}</PostElementParagraph>
					<PostElementParagraph>{t("SECTION_DESCRIPTION_1_22")}</PostElementParagraph>
					<PostElementParagraph>{t("SECTION_DESCRIPTION_1_23")}</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_DESCRIPTION_1_24")}</Html>
					</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_DESCRIPTION_1_25")}</Html>
					</PostElementParagraph>
					<PostElementParagraph>{t("SECTION_DESCRIPTION_1_26")}</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_DESCRIPTION_1_27")}</Html>
					</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_DESCRIPTION_1_28")}</Html>
					</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_DESCRIPTION_1_29")}</Html>
					</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_DESCRIPTION_1_30")}</Html>
					</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_DESCRIPTION_1_31")}</Html>
					</PostElementParagraph>

					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_TITLE_2")}</Html>
					</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_DESCRIPTION_2_1")}</Html>
					</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_DESCRIPTION_2_2")}</Html>
					</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_DESCRIPTION_2_3")}</Html>
					</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_DESCRIPTION_2_4")}</Html>
					</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_DESCRIPTION_2_5")}</Html>
					</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_DESCRIPTION_2_6")}</Html>
					</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_DESCRIPTION_2_7")}</Html>
					</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_DESCRIPTION_2_8")}</Html>
					</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_DESCRIPTION_2_9")}</Html>
					</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_DESCRIPTION_2_10")}</Html>
					</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_DESCRIPTION_2_11")}</Html>
					</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_DESCRIPTION_2_12")}</Html>
					</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_DESCRIPTION_2_13")}</Html>
					</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">
							{t("SECTION_DESCRIPTION_2_14", { goSupport: routes.external.goSupport })}
						</Html>
					</PostElementParagraph>
					<PostElementParagraph>{t("SECTION_DESCRIPTION_2_15")}</PostElementParagraph>

					<PostElementTitleH2 id="attachment_1">{t("SECTION_TITLE_3")}</PostElementTitleH2>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_3_LIST_1")}</Html>
					</PostElementParagraph>
					<PostElementOl>
						<PostElementListItem>
							<Html Tag="span">{t("SECTION_3_LIST_1_1")}</Html>
						</PostElementListItem>
						<PostElementListItem>
							<Html Tag="span">{t("SECTION_3_LIST_1_2")}</Html>
						</PostElementListItem>
						<PostElementListItem>
							<Html Tag="span">{t("SECTION_3_LIST_1_3")}</Html>
						</PostElementListItem>
						<PostElementListItem>
							<Html Tag="span">{t("SECTION_3_LIST_1_4")}</Html>
						</PostElementListItem>
					</PostElementOl>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_3_LIST_2")}</Html>
					</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_3_LIST_2_1")}</Html>
					</PostElementParagraph>
					<PostElementOl>
						<PostElementListItem>
							<Html Tag="span">{t("SECTION_3_LIST_2_1_1")}</Html>
						</PostElementListItem>
						<PostElementListItem>
							<Html Tag="span">{t("SECTION_3_LIST_2_1_2")}</Html>
						</PostElementListItem>
						<PostElementListItem>
							<Html Tag="span">{t("SECTION_3_LIST_2_1_3")}</Html>
						</PostElementListItem>
						<PostElementListItem>
							<Html Tag="span">{t("SECTION_3_LIST_2_1_4")}</Html>
						</PostElementListItem>
					</PostElementOl>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_3_LIST_3")}</Html>
					</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_3_LIST_4")}</Html>
					</PostElementParagraph>
					<PostElementOl>
						<PostElementListItem>
							<Html Tag="span">{t("SECTION_3_LIST_4_1")}</Html>
						</PostElementListItem>
						<PostElementListItem>
							<Html Tag="span">{t("SECTION_3_LIST_4_2")}</Html>
						</PostElementListItem>
						<PostElementListItem>
							<Html Tag="span">{t("SECTION_3_LIST_4_3")}</Html>
						</PostElementListItem>
						<PostElementListItem>
							<Html Tag="span">{t("SECTION_3_LIST_4_4")}</Html>
						</PostElementListItem>
						<PostElementListItem>
							<Html Tag="span">{t("SECTION_3_LIST_4_5")}</Html>
						</PostElementListItem>
						<PostElementListItem>
							<Html Tag="span">{t("SECTION_3_LIST_4_6")}</Html>
						</PostElementListItem>
						<PostElementListItem>
							<Html Tag="span">{t("SECTION_3_LIST_4_7")}</Html>
						</PostElementListItem>
					</PostElementOl>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_3_LIST_5")}</Html>
					</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_3_LIST_6")}</Html>
					</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_3_LIST_7")}</Html>
					</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_3_LIST_8")}</Html>
					</PostElementParagraph>

					<PostElementTitleH2 id="attachment_2">{t("SECTION_TITLE_4")}</PostElementTitleH2>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_4_LIST_1")}</Html>
					</PostElementParagraph>
					<Block spacing={{ pl: 4 }}>
						<PostElementParagraph>
							<Html Tag="span">{t("SECTION_4_LIST_1_1")}</Html>
						</PostElementParagraph>
						<PostElementParagraph>
							<Html Tag="span">{t("SECTION_4_LIST_1_2")}</Html>
						</PostElementParagraph>
						<PostElementParagraph>
							<Html Tag="span">{t("SECTION_4_LIST_1_3")}</Html>
						</PostElementParagraph>
						<PostElementParagraph>
							<Html Tag="span">{t("SECTION_4_LIST_1_4")}</Html>
						</PostElementParagraph>
					</Block>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_4_LIST_2")}</Html>
					</PostElementParagraph>
					<PostElementOl>
						<PostElementListItem>
							<Html Tag="span">{t("SECTION_4_LIST_2_1")}</Html>
						</PostElementListItem>
						<PostElementListItem>
							<Html Tag="span">{t("SECTION_4_LIST_2_2")}</Html>
						</PostElementListItem>
						<PostElementListItem>
							<Html Tag="span">{t("SECTION_4_LIST_2_3")}</Html>
						</PostElementListItem>
						<PostElementListItem>
							<Html Tag="span">{t("SECTION_4_LIST_2_4")}</Html>
						</PostElementListItem>
					</PostElementOl>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_4_LIST_3")}</Html>
					</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_4_LIST_4")}</Html>
					</PostElementParagraph>
					<PostElementOl>
						<PostElementListItem>
							<Html Tag="span">{t("SECTION_4_LIST_4_1")}</Html>
						</PostElementListItem>
						<PostElementListItem>
							<Html Tag="span">{t("SECTION_4_LIST_4_2")}</Html>
						</PostElementListItem>
					</PostElementOl>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_4_LIST_5")}</Html>
					</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">
							{t("SECTION_4_LIST_6", { privacyPolicy: routes.external.privacyPolicy })}
						</Html>
					</PostElementParagraph>
					<PostElementParagraph spacing={{ pl: 4 }}>{t("SECTION_4_LIST_6_1")}</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">{t("SECTION_4_LIST_7")}</Html>
					</PostElementParagraph>
				</GuidePageTemplateMain>
			</GuidePageTemplate>
			<SectionTryForFree />
		</SiteLayout>
	);
};

export default ProductTerms;
